<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const versions = computed(() => store.state.result.versions);
const index = computed(() => store.state.result.versionIndex);
const busy = computed(
  () => store.state.result.loading || store.state.result.loadingFix
);
const select = (to) => store.dispatch("result/selectVersion", to);
</script>

<template>
  <nav
    v-if="versions.length > 1"
    class="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-secondary"
    aria-label="Versions of this make"
  >
    <span class="flex items-center gap-2">
      <button
        type="button"
        class="rounded-full p-2 hover:bg-gray-10 hover:text-primary disabled:opacity-40"
        :disabled="busy || index <= 0"
        aria-label="Previous version"
        @click="select(index - 1)"
      >
        <font-awesome-icon :icon="['fas', 'chevron-left']" />
      </button>
      <span class="font-bold text-primary" aria-live="polite">
        Version {{ index + 1 }} of {{ versions.length }}
      </span>
      <button
        type="button"
        class="rounded-full p-2 hover:bg-gray-10 hover:text-primary disabled:opacity-40"
        :disabled="busy || index >= versions.length - 1"
        aria-label="Next version"
        @click="select(index + 1)"
      >
        <font-awesome-icon :icon="['fas', 'chevron-right']" />
      </button>
    </span>
    <button
      v-if="index > 0"
      type="button"
      class="flex items-center font-bold uppercase text-accentPrimary hover:text-purple-400 disabled:opacity-40"
      :disabled="busy"
      @click="select(index - 1)"
    >
      <font-awesome-icon :icon="['fas', 'rotate-left']" class="mr-2" />
      Undo
    </button>
  </nav>
</template>
